define('ProductDetails.QuickView.View.Extension', [
  'ProductDetails.QuickView.View',
  'ShopByModel.Model',
  'underscore'
], function (
  ProductDetailsQuickViewView,
  GoferModelModel,
  _
) {
  'use strict';

  _.extend(ProductDetailsQuickViewView.prototype, {

    initialize: _.wrap(ProductDetailsQuickViewView.prototype.initialize, function (fn) {
      try {

        fn.apply(this, _.toArray(arguments).slice(1));

        this.args = this.parseArgs();
        this.goferModel = null;
        this.xRefItems = [];

        if (this.args.isDiagramPage) {
          this.goferModel = new GoferModelModel();
          this.application.getLayout().once(
            'afterAppendView',
            function () {
              this.getXRefItems();
            },
            this
          );
        }

      } catch(err) { console.error(802889, err); }
    }),

    events: _.extend(ProductDetailsQuickViewView.prototype.events, {
      'click .gofer-diagrams-xref-item-link': 'onClickXRefLink'
    }),

    parseArgs: function() {
      try {
        var argString = (Array.from(this.arguments) || [])[0] || '';
        var argParts1 = argString.split('?');
        var argParts2 = argParts1[1].split('&');
        var args = {
          itemUrlComponent: argParts1[0]
        };
        argParts2.forEach(function(part)  {
          var keyValue = part.split('=');
          var key = keyValue[0];
          var value = keyValue[1];
          args[key] = value == 'true' ? true : value == 'false' ? false : value;
        });
        return args;
      } catch(err) { console.error(619942, err); }
    },

    getXRefItems: function(urlComponent) {
      try {

        var url = urlComponent || this.args.itemUrlComponent;

        // Get item via Item API (quicker than SuiteScript search) using URL component
        this.model.get('item').fetch({ data: { url: url } }).then(function (res) {

          var item = ((res || {}).items || [])[0];
          if (!item) { return; }
          this.model.set('item', item);

          // Get xRef items from backend Gofer Model using item ID
          var data = {
            action: 'getXRefItems',
            goferModel: this.args.modelName,
            itemId: item.internalid
          };

          this.goferModel.fetch({ data: data }).then(function(res) {
            try {
              this.xRefItems = res;
              this.render();
            } catch(err) { console.error(834856, err); }
          }).fail(function(err) {
            console.error(204020, err);
          });

        });

      } catch(err) { console.error(721059, err); }
    },

    onClickXRefLink: function(e) {
      try {
        var urlComponent = this.$(e.target).attr('data-urlcomponent');
        this.getXRefItems(urlComponent);
        return false; // Prevents navigation with href
      } catch(err) { console.error(204923, err); }
    },

    getContext: _.wrap(ProductDetailsQuickViewView.prototype.getContext, function (fn) {
      try {
        var context = fn.apply(this, _.toArray(arguments).slice(1));
        context.xRefItems = this.xRefItems;
        context.showXRefItems = this.xRefItems.length > 0;
        //context.pageHeader = 'testing';
        context.pageHeader = this.model.get('item').get('_pageHeader');
        return context;
      } catch(err) { console.error(420471, err); }
    })

  });

});
